import { render, staticRenderFns } from "./AllBatchEntriesTable.vue?vue&type=template&id=a96320f4&scoped=true&"
import script from "./AllBatchEntriesTable.vue?vue&type=script&lang=js&"
export * from "./AllBatchEntriesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllBatchEntriesTable.vue?vue&type=style&index=0&id=a96320f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96320f4",
  null
  
)

export default component.exports